import { SupplierOptionDto } from '../../../dto/reference';
import { fetchSupplierOptions } from '../api/referenceDataApi';
import { useReferenceOptions } from './useReferenceOptions';

export function useSupplierOptions(enabled = true) {
  return useReferenceOptions<SupplierOptionDto>(fetchSupplierOptions, enabled);
}
